<template>
<div class="page worktime">
  <h1>Ingave uren</h1>
</div>
</template>

<script>
export default {
name: "Worktime"
}
</script>
